"use client";

import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import CommonHero from "@/components/CommonHero";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar"

export default function TermsOfService() {
  const sections = [
    {
      title: "1. Acceptance of Terms",
      content: "By accessing and using AWS Businessmen Services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services."
    },
    {
      title: "2. Services Provided",
      content: "AWS Businessmen Services provides business setup, visa processing, corporate banking assistance, and related corporate services in the UAE. We reserve the right to modify or discontinue any service at any time."
    },
    {
      title: "3. User Responsibilities",
      content: "Users are responsible for providing accurate and complete information required for service delivery. Any delays or issues caused by inaccurate information are the responsibility of the user."
    },
    {
      title: "4. Fees and Payments",
      content: "Service fees are quoted based on the specific requirements of the user. Payments must be made in accordance with the agreed-upon schedule. All fees are non-refundable unless otherwise specified."
    },
    {
      title: "5. Limitation of Liability",
      content: "AWS Businessmen Services shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services or inability to access them."
    },
    {
      title: "6. Governing Law",
      content: "These terms are governed by the laws of the United Arab Emirates. Any disputes shall be resolved in the courts of Ajman, UAE."
    }
  ];

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <main className="bg-white">
        <section className="bg-[#fafafa] border-b border-gray-100 pt-24">
          <div className="max-w-4xl mx-auto px-6">
            <div className="flex items-center gap-4 mb-6">
              <Link
                href="/"
                className="flex items-center gap-2 text-[#B8893A] hover:text-[#A67B34] transition-colors"
              >
                <ArrowLeft size={20} />
                <span className="font-medium">Back to Home</span>
              </Link>
            </div>
          </div>
        </section>

        <CommonHero
          badge="Legal"
          title="Terms of"
          highlight="Service"
          description="Please read these terms carefully before using our services."
        />

        <section className="py-16 sm:py-20 px-6">
          <div className="max-w-4xl mx-auto">
            {sections.map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="mb-12"
              >
                <h2 className="text-2xl font-bold text-[#0A0A0A] mb-4">{section.title}</h2>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {section.content}
                </p>
              </motion.div>
            ))}
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mt-16 p-8 rounded-2xl bg-gray-50 border border-gray-100"
            >
              <h3 className="text-xl font-bold text-[#0A0A0A] mb-2">Questions?</h3>
              <p className="text-gray-600">
                If you have any questions about our Terms of Service, please contact us at info@awsbusinessmen.com.
              </p>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
